module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/foot-241c84343428eeb5061c3b239cae6e63.png";